import { getText } from "shared/lib";

import {
  AnimatedText,
  GridLoader,
  ProgressIndicatorList,
  type ProgressIndicatorListProps,
} from "shared/components";

export interface ApplicationRequirementsLoaderProps {
  title: string;
  items: ProgressIndicatorListProps["items"];
}

export function ApplicationRequirementsLoader({
  items,
  title,
}: ApplicationRequirementsLoaderProps) {
  return (
    <div className="flex flex-col gap-3" data-testid="report-loading-indicator">
      <div className="text-textSubdued content-start">
        <h3 className="text-textDisabled text-headinglg mb-1 flex flex-row">
          {title}
          <AnimatedText text="..." />
        </h3>

        <p className="text-textSubdued text-bodymd">
          {getText("This normally takes 1-3 minutes depending on the complexity of your proposal.")}
        </p>
      </div>

      <GridLoader />

      <ProgressIndicatorList items={items} />
    </div>
  );
}
